import React, { Component, Fragment } from "react";
import { Heading, Text } from "components/styled";
import { DottedPlot } from "../../visualization";
import styled from "styled-components";
import { connect } from "react-redux";
import { getProjectsByContractorType } from "../../../infraMonitor/filters";
import {
  dashboardLocalization,
  number,
  helpTextLocalization
} from "localization";
import { images } from "../../../config/index";

class ProjectContractorTypeChart extends Component {
  state = {};
  filterData(projectsByContractorType, ward) {
    if (ward === "all") {
      return projectsByContractorType;
    }
    const filteredData = {};
    Object.keys(projectsByContractorType).forEach(key => {
      filteredData[key] = projectsByContractorType[key].filter(
        d => d.wards && d.wards.includes(String(ward))
      );
    });
    return filteredData;
  }
  getFragment(selectedWard, selectedLanguage) {
    if (selectedWard === "all") return null;

    if (selectedLanguage === "en") {
      return (
        <Fragment>
          for <strong>Ward {number(selectedWard)}</strong>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <strong>वडा {number(selectedWard)}</strong> का लागि
      </Fragment>
    );
  }
  render() {
    const {
      projectsByContractorType,
      selectedWard,
      selectedLanguage,
      overall
    } = this.props;
    const types = this.filterData(projectsByContractorType, selectedWard);
    const { dotChartTitle } = dashboardLocalization[selectedLanguage];
    const { dotChart: dotChartHelpText } = helpTextLocalization[
      selectedLanguage
    ];

    if (!overall.contractor_type) {
      return null;
    }

    return (
      <ChartsBlock className="charts-block" lang={selectedLanguage}>
        <Heading.h2 uppercase className="flex items-center">
          <Text.span className="help-text">
            <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
            <Text.span className="help-text__content tooltip">
              <Text.span className="tooltip-arrow">arrow</Text.span>
              {dotChartHelpText}
            </Text.span>
          </Text.span>
          <Text.span>
            {selectedLanguage === "en" && `${dotChartTitle} `}
            {this.getFragment(selectedWard, selectedLanguage)}
            {selectedLanguage === "np" && ` ${dotChartTitle}`}
          </Text.span>
        </Heading.h2>
        <Wrapper>
          <div id="dot-tooltip" />
          <DottedPlot types={types} />
        </Wrapper>
      </ChartsBlock>
    );
  }
}

const Wrapper = styled.div`
  min-height: 173px;
`;

const ChartsBlock = styled.div`
  h2 {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    > span:last-child {
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      opacity: 0.7;
    }
  }
`;

const mapStateToProps = state => ({
  projectsByContractorType: getProjectsByContractorType(
    state.infraMonitor.projects
  ),
  // abc: state.infraMonitor.projects,
  selectedWard: state.projectsStatsReducers.selectedWard,
  selectedLanguage: state.localizationReducers.selectedLanguage,
  overall: state.projectsStatsReducers.data.data.overall
});

export default connect(mapStateToProps)(ProjectContractorTypeChart);



// WEBPACK FOOTER //
// ./src/components/layouts/projectContractorTypeChart/projectContractorTypeChart.js